
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1wzqe_q3u5u_93",
  "search-field": "awsui_search-field_1wzqe_q3u5u_104",
  "input-wrapper": "awsui_input-wrapper_1wzqe_q3u5u_110",
  "add-token": "awsui_add-token_1wzqe_q3u5u_114",
  "tokens": "awsui_tokens_1wzqe_q3u5u_121",
  "token-operator": "awsui_token-operator_1wzqe_q3u5u_125",
  "token-editor": "awsui_token-editor_1wzqe_q3u5u_129",
  "token-editor-line": "awsui_token-editor-line_1wzqe_q3u5u_136",
  "token-editor-label": "awsui_token-editor-label_1wzqe_q3u5u_141",
  "token-editor-field": "awsui_token-editor-field_1wzqe_q3u5u_146",
  "token-editor-actions": "awsui_token-editor-actions_1wzqe_q3u5u_151",
  "token-editor-commit": "awsui_token-editor-commit_1wzqe_q3u5u_156",
  "custom-control": "awsui_custom-control_1wzqe_q3u5u_160",
  "input": "awsui_input_1wzqe_q3u5u_110",
  "results": "awsui_results_1wzqe_q3u5u_168",
  "results-visible": "awsui_results-visible_1wzqe_q3u5u_174",
  "separator": "awsui_separator_1wzqe_q3u5u_178",
  "toggle-collapsed": "awsui_toggle-collapsed_1wzqe_q3u5u_185",
  "token-trigger": "awsui_token-trigger_1wzqe_q3u5u_190",
  "token-editor-cancel": "awsui_token-editor-cancel_1wzqe_q3u5u_196",
  "remove-all": "awsui_remove-all_1wzqe_q3u5u_200",
  "token-label": "awsui_token-label_1wzqe_q3u5u_201",
  "join-operation": "awsui_join-operation_1wzqe_q3u5u_202",
  "property-selector": "awsui_property-selector_1wzqe_q3u5u_203",
  "operator-selector": "awsui_operator-selector_1wzqe_q3u5u_204",
  "value-selector": "awsui_value-selector_1wzqe_q3u5u_205",
  "token-editor-submit": "awsui_token-editor-submit_1wzqe_q3u5u_206"
};
  